import { createFileRoute, redirect } from '@tanstack/react-router'
import { isSuperAdmin } from '@/lib/authorization'
import {
  isDesktopLoginContext,
  latchDesktopLoginContext,
} from '@/features/auth/utils/desktop-login-context'

export const Route = createFileRoute('/')({
  beforeLoad: ({ context: { auth } }) => {
    latchDesktopLoginContext()

    if (auth.loading) return
    if (!auth.isActive) return

    if (isDesktopLoginContext()) return

    if (isSuperAdmin(auth.userInfo)) {
      throw redirect({ to: '/superadmin/overview' })
    }

    const cityKey = auth.userInfo?.cityKey
    if (cityKey) {
      throw redirect({
        to: '/city-clerk/$id/dashboard',
        params: { id: cityKey },
      })
    }
  },
})
